import { Box, Button, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import CustomTypography from '../../ui/atoms/CustomTypography';
import { contextValue } from '../../constants';
import useQueryObject from '../../hooks/useQueryObject';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import useGetLuggage from './hooks/getLuggage';
import { RootState } from '../../redux/Store';
import { getScriptData as getCorescriptData } from '../../redux/reducer/coreScriptReducer';
type HeaderInfoProps = {
  luggageData: any;
};

const HeaderInfo = ({ luggageData }: HeaderInfoProps) => {
  const { contextId, queryObj } = useSelector(
    (state: RootState) => state.contextId
  );

  const scriptData = useSelector(getCorescriptData);

  const headerInfo = useMemo(() => {
    if (luggageData && queryObj?.context === contextValue?.INSPI) {
      try {
        const data = JSON.parse(luggageData);
        const questions = data?.Luggages?.PROPERTY?.questions;
        const address1 =
          questions?.ADDRESS1?.answers?.[0] ??
          questions?.['Property.TblAddress1']?.answers?.[0] ??
          '';
        const address2 =
          questions?.ADDRESS1?.answers?.[0] ??
          questions?.['Property.TblAddress2']?.answers?.[0] ??
          '';
        const city =
          questions?.ADDRESS1?.answers?.[0] ??
          questions?.['Property.TblCity']?.answers?.[0] ??
          '';
        const state =
          questions?.ADDRESS1?.answers?.[0] ??
          questions?.['Property.TblState']?.answers?.[0] ??
          '';
        const zip =
          questions?.ADDRESS1?.answers?.[0] ??
          questions?.['Property.TblZip']?.answers?.[0] ??
          '';

        // Format as on an envelope
        // Address Line 1
        // Address Line 2 (if present)
        // City, State ZIP
        return (
          <>
            {address1 && (
              <>
                <br />
                {address1}
                <br />
              </>
            )}
            {address2 && (
              <>
                {address2}
                <br />
              </>
            )}
            {(city || state || zip) && (
              <>
                {city}
                {city && state ? ', ' : ''}
                {state} {zip}
              </>
            )}
          </>
        );
      } catch {
        return '';
      }
    }
    return scriptData?.Name || '';
  }, [scriptData, luggageData, queryObj?.context]);

  return (
    <CustomTypography
      variant='h5'
      sx={{
        color: '#343330',
        fontFamily: 'Montserrat',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: 'normal',
        textTransform: 'capitalize',
      }}
    >
      {headerInfo}
    </CustomTypography>
  );
};

export default HeaderInfo;
